import { useMutation } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import type { PortfolioExportFilter } from "@/api/types";
import { useFlashToast } from "@/components/FlashToast/FlashToast";
import { downloadFile } from "@/helpers/file-parse";
import { useTranslation } from "@/translations";

const useExportProjectAnalytics = () => {
  const api = useApi();
  const showFlashToast = useFlashToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (payload: { data: PortfolioExportFilter; fileName: string }) => api.postProjectExportV1(payload.data),
    onSuccess: async (data, payload) => {
      const blob = await data.blob();
      downloadFile(blob, payload.fileName);

      showFlashToast({
        type: "success",
        title: t("page.portfolio.overview.notification.export.success", {
          count: payload.data.projectIds.length,
        }),
      });
    },
    onError: () => {
      showFlashToast({
        type: "error",
        title: t("page.portfolio.overview.notification.export.error"),
      });
    },
  });
};

export const portfolioMutations = {
  useExportProjectAnalytics,
};
